import { toast } from 'sonner'
import { trpc } from '@/config/trpc'
import { trackConnectorConnectStarted } from '@/lib/analytics/connectionTracking'
import { startNotionAuth } from '@/lib/auth/notion'
import { Button } from '@/components/ui/shadcn/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/shadcn/card'
import { DisconnectConnectionDialog } from './disconnect-connection-dialog'

// Brand-level Notion connection. Read-only source of pages/databases the user shares with the
// integration. Distinct from social accounts (which we post TO).
export function NotionConnectionCard() {
  const { data: config } = trpc.brandConnection.notionConfig.useQuery()
  const { data: connections } = trpc.brandConnection.list.useQuery()

  const notion = connections?.find((c) => c.provider === 'notion')
  const meta = notion?.metadata as { workspaceName?: string } | undefined

  const handleConnect = () => {
    if (!config?.clientId) {
      toast.error('Notion is not configured for this environment')
      return
    }
    trackConnectorConnectStarted('notion', !!notion)
    startNotionAuth({ clientId: config.clientId, referrerPath: window.location.pathname })
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Notion</CardTitle>
        <CardDescription>
          Pages and databases you share with the integration. Read-only, never posted to.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="flex items-center justify-between gap-4 rounded-lg border p-4">
          <div className="min-w-0">
            {config?.configured === false ? (
              <p className="text-muted-foreground text-sm">Not configured for this environment.</p>
            ) : notion ? (
              <p className="text-foreground truncate text-sm">
                Connected{meta?.workspaceName ? ` to ${meta.workspaceName}` : ''}
              </p>
            ) : (
              <p className="text-muted-foreground text-sm">Not connected.</p>
            )}
          </div>
          {notion ? (
            <div className="flex shrink-0 items-center gap-2">
              {/* Re-authorizing re-opens Notion's page picker to change what's shared. */}
              <Button
                variant="outline"
                onClick={handleConnect}
                disabled={config?.configured === false}>
                Manage pages
              </Button>
              <DisconnectConnectionDialog provider="notion">
                <Button variant="ghost">Disconnect</Button>
              </DisconnectConnectionDialog>
            </div>
          ) : (
            <Button onClick={handleConnect} disabled={config?.configured === false}>
              Connect
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  )
}
